export const setPort = (port) => ({ type: "SET_PORT", payload: port });

export const setReader = (reader) => ({ type: "SET_READER", payload: reader });